import { Injectable, inject } from "@angular/core";
import { CanActivate } from "@angular/router";
import { sntLog } from "src/app/common/logger";
import { BootstrapService } from "src/app/modules/bootstrap/bootstrap.service";
import { MemberStorageService } from "src/app/services/member-storage.service";
import { PlatformService } from "src/app/services/platform.service";
import { SettingsService } from "src/app/services/settings.service";

const logger = sntLog("EnableThemeGuard");

@Injectable()
export class EnableThemeGuard implements CanActivate {
  private readonly bootstrapService = inject(BootstrapService);
  private readonly settingsService = inject(SettingsService);
  private readonly platoformService = inject(PlatformService);
  private readonly memberStorageService = inject(MemberStorageService);

  async canActivate(): Promise<boolean> {
    logger.info("canActivate");

    if (this.platoformService.isMobile()) {
      return true;
    }

    const localStorageThemeValue = <"light" | "dark" | null>(
      this.memberStorageService.getItem("theme")
    );

    if (!localStorageThemeValue) {
      const uiSettings = this.settingsService.getUiSettings();

      if (uiSettings.theme) {
        this.bootstrapService.changeCurrentTheme(uiSettings.theme);
      }
    } else {
      this.bootstrapService.changeCurrentTheme(localStorageThemeValue);
    }

    return true;
  }
}
